import {CompetitionViewModel} from "../../../domain/common/competition/models/competition-view-model";

export class RelatedEntitiesWidgetCompetitionViewModel extends CompetitionViewModel {

  get relatedEntitySubText(): String {
    return this.country.name;
  }
}
